import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9bdc4dce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9bdc4dce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdc4dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/卡百利业务中台2.0（前端）生产环境/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bdc4dce')) {
      api.createRecord('9bdc4dce', component.options)
    } else {
      api.reload('9bdc4dce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9bdc4dce&scoped=true", function () {
      api.rerender('9bdc4dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/VabAvatar/index.vue"
export default component.exports